import AutoTable from './AutoTable'
export default AutoTable
